<script>
export default {
    mounted() {
        this.$el
            .querySelectorAll("[id], [for]")
            .forEach((item, index, sourceArr) => {
                if (item.hasAttribute("id"))
                    item.setAttribute(
                        "id",
                        `${this._uid}-${item.getAttribute("id")}`
                    );
                if (item.hasAttribute("for"))
                    item.setAttribute(
                        "for",
                        `${this._uid}-${item.getAttribute("for")}`
                    );
            });
    },
    methods: {
        printLog() {
            myConsoleLog(...arguments);
        }
    },
};
</script>
